<template>
  <StoreSkeleton v-if="!isInitialized" class="margin-left-xs" />
  <button v-else class="rail-btn-hover rail-btn-nowrap margin-left-xs" aria-haspopup="dialog" @click="openStoreSlideout">
    <i class="icon-28x28 your-store-icon"></i>
    <AsideText :subtitle="subtitle" class="nav-aside-text margin-left-xxs">Your store</AsideText>
  </button>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { ref, computed } from 'vue';
import { GET_ZIP_CODE } from '#shared/types/getters';
import AsideText from './AsideText.common';
import StoreSkeleton from './StoreSkeleton';
import { onPreferredStoreReady } from '~/events';
import useStoreSlideout from '~/composables/features/useStoreSlideout';
import useAccount from '~/composables/useAccount';

const navPreferred = useNavPreferred();
const isInitialized = ref(false);
const { isSignedIn } = useAccount();
const zipCode = computed(() => navPreferred?.[GET_ZIP_CODE]);
const subtitle = computed(() => (isSignedIn.value ? zipCode.value : ''));

const { openStoreSlideout } = useStoreSlideout();

onPreferredStoreReady(() => {
  isInitialized.value = true;
});
</script>

<style lang="scss" brand="mcom">
@import '~/assets/scss/icons.mcom.scss';

.your-store-icon {
  @extend .store-mode-dark-large;
}
</style>

<style lang="scss" brand="bcom" scoped>
@import '~/assets/scss/classes.bcom.scss';

.your-store-icon {
  @extend .store-icon-condensed;
}
@media only screen and (max-width: 1200px) {
  :deep(.nav-aside-text) {
    display: none;
  }
}
</style>
